import * as React from 'react'
import { JsTree } from '../../../../components/ui/JsTree';
import { NewProjectHttp } from '../../http';
import { IHierarchyReference, IJsTreeCoreDataNode } from '../../interfaces';

interface IHierarchyJsTreeProps {
  values: IHierarchyReference[]
  onChange: (values: IHierarchyReference[]) => void
  project: string
  required?: boolean
}

interface IHierarchyJsTreeState {
  selected: string[]
  hierarchys: IHierarchyReference[]
  data: IJsTreeCoreDataNode[]
}

export class HierarchyJsTree extends React.Component<IHierarchyJsTreeProps, IHierarchyJsTreeState> {
  state: IHierarchyJsTreeState = {
    selected: [],
    hierarchys: [],
    data: []
  }

  lastProject = ''

  componentWillMount() {
    this.loadHierarchyNodes()
  }

  componentWillReceiveProps(nextProps: IHierarchyJsTreeProps) {
    this.loadHierarchyNodes(nextProps)
  }

  loadHierarchyNodes(props = this.props) {
    const { project, values } = props
    const selected = values.map((value) => value.avid)

    this.setState({ selected })

    if (this.lastProject === project) {
      return
    }

    this.lastProject = project
    this.setState({ data: undefined })

    NewProjectHttp.getHierarchies(project).then((projectHierarchys) => {
      const hierarchys = projectHierarchys[0].hierarchyReferences
      const data = NewProjectHttp.mapHierarchiesToJsTreeNodes(hierarchys)

      this.setState({ hierarchys, data })
    })
  }

  onChange(selected: string[]) {
    const { hierarchys } = this.state

    const values: IHierarchyReference[] = selected.map((avid) => {
      return hierarchys.find((hierarchy) => hierarchy.avid === avid)
    })

    this.props.onChange(values)
  }

  render() {
    const { project } = this.props
    const { hierarchys, data } = this.state
    const error = () => { /**/ }
    const hierOptions: JSTreeStaticDefaults = {
      plugins: ['wholerow', 'checkbox'],
      core: { error, data }
    }

    if (!project || !data) {
      return (
        <small>Loading Hierarchys...</small>
      )
    }

    return (
      <section style={{ position: 'relative' }}>
        <input type="text" style={{ position: 'absolute', top: 15, left: 50, height: 1, width: 1, opacity: 0 }}
          required={this.props.required}
          value={this.props.values.length > 0 ? 'defined' : ''}
        />
        <article style={{ minHeight: 275, maxHeight: 275, overflowY: 'auto' }}>
          <JsTree
            // defaultTree="default_hierarchy_tree"
            // selectedInput="hierarchySelected"
            options={hierOptions}
            selected={this.state.selected}
            onChange={(selected) => this.onChange(selected)}
          />
        </article>
      </section>
    )
  }
}
